<template>
  <div class="site-settings">
    <div class="site-settings__header">
      <div class="site-settings__header__tabs">
        <a
          :class="[
            'site-settings__header__tabs__tab',
            {
              'site-settings__header__tabs__tab--active':
                currentTab === 'GlobalSettings',
            },
          ]"
          @click="goToStep('GlobalSettings')"
        >
          Étape 1
        </a>

        <a
          :class="[
            'site-settings__header__tabs__tab',
            {
              'site-settings__header__tabs__tab--active':
                currentTab === 'SpecialityTab',
            },
          ]"
          @click="goToStep('SpecialityTab')"
        >
          Étape 2
        </a>

        <a
          :class="[
            'site-settings__header__tabs__tab',
            {
              'site-settings__header__tabs__tab--active': currentTab === 'LawFirm',
            },
          ]"
          @click="goToStep('LawFirm')"
        >
          Étape 3
        </a>

        <a
          :class="[
            'site-settings__header__tabs__tab',
            {
              'site-settings__header__tabs__tab--active': currentTab === 'Coworkers',
            },
          ]"
          @click="goToStep('Coworkers')"
        >
          Étape 4
        </a>

        <a
          :class="[
            'site-settings__header__tabs__tab',
            {
              'site-settings__header__tabs__tab--active':
                currentTab === 'DesignSettings',
            },
          ]"
          @click="goToStep('DesignSettings')"
        >
          Étape 5
        </a>

        <a
          :class="[
            'site-settings__header__tabs__tab',
            { 'site-settings__header__tabs__tab--active': currentTab === 'Legals' },
          ]"
          @click="goToStep('Legals')"
        >
          Étape 6
        </a>
        <a
          :class="[
            'site-settings__header__tabs__tab',
            {
              'site-settings__header__tabs__tab--active': currentTab === 'LiveEdit',
            },
          ]"
          @click="goToStep('LiveEdit')"
        >
          <img
            src="@/assets/svg/live-edit.svg"
            class="site-settings__header__tabs__tab__icon"
            alt=""
          />
          Prévisualisation
        </a>

        <a
          v-if="currentTab !== 'LiveEdit'"
          class="site-settings__header__tabs__tab site-settings__header__tabs__tab--active site-settings__visibility-icon"
          @click="goToStep('GlobalSettings')"
        >
          <div v-if="isSiteVersionInvisible || !isPublished" class="offline">
            <img src="@/assets/svg/icon-invisible-red.svg" alt="" class="icon" />
            <span class="state">Hors ligne</span>
          </div>
          <div v-else class="online">
            <img src="@/assets/svg/icon-visible.svg" alt="" class="icon" />
            <span class="state">En ligne</span>
          </div>
        </a>
      </div>
      <div class="site-settings__header__cta">
        <div v-if="displayLiveEditCtas" class="site-settings__header__cta__icons">
          <img
            src="@/assets/svg/preview-desktop.svg"
            alt=""
            :class="[
              'site-settings__header__cta__icon',
              {
                'site-settings__header__cta__icon--active':
                  previewSize === previewSizeDesktop,
              },
            ]"
            @click="previewSize = previewSizeDesktop"
          />
          <img
            src="@/assets/svg/preview-tablet.svg"
            alt=""
            :class="[
              'site-settings__header__cta__icon',
              {
                'site-settings__header__cta__icon--active':
                  previewSize === previewSizeTablet,
              },
            ]"
            @click="previewSize = previewSizeTablet"
          />
          <img
            src="@/assets/svg/preview-mobile.svg"
            alt=""
            :class="[
              'site-settings__header__cta__icon',
              {
                'site-settings__header__cta__icon--active':
                  previewSize === previewSizeMobile,
              },
            ]"
            @click="previewSize = previewSizeMobile"
          />
        </div>
        <button
          v-if="currentTab === 'LiveEdit'"
          class="site-settings__header__cta__button button button--negative button--x-small"
          @click="save"
        >
          ENREGISTRER
        </button>
        <button
          v-if="currentTab === 'LiveEdit'"
          class="site-settings__header__cta__button button button--x-small"
          @click="publish"
        >
          PUBLIER
        </button>
      </div>
    </div>
    <div class="site-settings__body">
      <GlobalSettings v-if="currentTab === 'GlobalSettings'" />
      <LawFirm v-if="currentTab === 'LawFirm'" />
      <SpecialityTab v-if="currentTab === 'SpecialityTab'" />
      <Coworkers v-if="currentTab === 'Coworkers'" />
      <DesignSettings v-if="currentTab === 'DesignSettings'" />
      <Legals v-if="currentTab === 'Legals'" />
      <LiveEdit v-if="currentTab === 'LiveEdit'" :preview-size="previewSize" />
      <div class="site-settings__step-buttons-wrapper">
        <button
          v-if="
            [
              'GlobalSettings',
              'SpecialityTab',
              'LawFirm',
              'Coworkers',
              'DesignSettings',
              'Legals',
            ].includes(currentTab)
          "
          class="site-settings__next-step-button button button--icon"
          @click="nextStep"
        >
          <span>Étape suivante</span>
        </button>
        <a
          v-show="
            [
              'DesignSettings',
              'SpecialityTab',
              'LawFirm',
              'Coworkers',
              'DesignSettings',
              'Legals',
            ].includes(currentTab)
          "
          class="site-settings__previous-step-button link"
          @click="previousStep"
        >
          <span>Retour à l'étape précédente</span>
        </a>
      </div>
    </div>
    <div class="site-settings__mobile-warning">
      <h1>
        Cette fonctionnalité n'est pour le moment pas disponible sur mobile
      </h1>
    </div>

    <transition name="modal">
      <Modal v-if="showSaveModal" icon>
        <template v-slot:header>
          <h3>Votre site est enregistré !</h3>
        </template>
        <template v-slot:body>
          <p class="text text--2 text--hint text--hint-light">
            Mais attention il n’est pas encore en ligne. Pour le mettre en ligne,
            veuillez cliquer sur Publier.
          </p>
        </template>
      </Modal>
    </transition>

    <transition name="modal">
      <Modal v-if="showPublishModal" icon>
        <template v-slot:header>
          <h3 v-if="isDraft" class="text--center">
            Bravo ! Votre site est en cours de mise en ligne. Il sera accessible
            d’ici 24H à 48H.
          </h3>
          <h3 v-else class="text--center">Votre site a été mis à jour</h3>
        </template>
      </Modal>
    </transition>
  </div>
</template>

<script>
import { api } from '@/lib/api';
import { mapGetters, mapActions } from 'vuex';
import { Modal } from '@/components';

import {
  GlobalSettings,
  DesignSettings,
  Legals,
  LiveEdit,
  LawFirm,
  SpecialityTab,
  Coworkers,
} from './Tabs';

export default {
  components: {
    Modal,
    GlobalSettings,
    LawFirm,
    SpecialityTab,
    Coworkers,
    DesignSettings,
    Legals,
    LiveEdit,
  },

  data() {
    return {
      showSaveModal: false,
      showPublishModal: false,
      previewSize: '100%',
      previewSizeMobile: '550px',
      previewSizeTablet: '992px',
      previewSizeDesktop: '100%',
      statusDraft: 'DRAFT',
      statusProd: 'PROD',
      currentTab: 'GlobalSettings',
    };
  },

  computed: {
    ...mapGetters({
      getSiteVersionState: 'siteVersion/getState',
      getSiteVersionSite: 'siteVersion/getSite',
      getSiteVersionStatus: 'siteVersion/getStatus',
      getOffice: 'office/getState',
      getSite: 'site/getState',
      getIsFirstVersionPublished: 'site/getIsFirstVersionPublished',
      isSiteVersionInvisible: 'siteVersion/isOnLine',
      getOfficeCoworkers: 'office/getCoworkers',
      isLastOnLine: 'siteVersion/isLastOnLine',
    }),

    displayLiveEditCtas() {
      return this.$route.name === 'LiveEdit';
    },

    isDraft() {
      return this.getSiteVersionStatus === 'DRAFT';
    },

    isPublished() {
      return this.getIsFirstVersionPublished;
    },
  },
  mounted() {
    const { hash } = this.$route;
    if (hash) this.goToStep(hash);
  },
  methods: {
    ...mapActions({
      updateSiteVersionStatus: 'siteVersion/updateStatus',
      updateSiteHostingSettings: 'site/updateHostingSettings',
      updateSiteOffice: 'site/updateOffice',
      updateSiteVersionSite: 'siteVersion/updateSite',
      updateOffice: 'office/updateOffice',
      updateSite: 'site/updateSite',
      putCoworkers: 'office/putCoworkers',
      updateOfficeSpecialities: 'office/updateSpecialities',
      updateOnLineUpdated: 'siteVersion/updateOnLineUpdated',
    }),

    nextStep() {
      switch (this.currentTab) {
        case 'GlobalSettings':
          this.currentTab = 'SpecialityTab';
          break;
        case 'SpecialityTab':
          this.currentTab = 'LawFirm';
          break;
        case 'LawFirm':
          this.currentTab = 'Coworkers';
          break;
        case 'Coworkers':
          this.currentTab = 'DesignSettings';
          break;
        case 'DesignSettings':
          this.currentTab = 'Legals';
          break;
        case 'Legals':
          this.currentTab = 'LiveEdit';
          break;
      }
      this.postSiteVersion();
      window.scrollTo(0, 0);
    },

    previousStep() {
      switch (this.currentTab) {
        case 'LiveEdit':
          this.currentTab = 'Legals';
          break;
        case 'Legals':
          this.currentTab = 'DesignSettings';
          break;
        case 'DesignSettings':
          this.currentTab = 'Coworkers';
          break;
        case 'Coworkers':
          this.currentTab = 'LawFirm';
          break;
        case 'LawFirm':
          this.currentTab = 'SpecialityTab';
          break;
        case 'SpecialityTab':
          this.currentTab = 'GlobalSettings';
          break;
      }
      this.postSiteVersion();
      window.scrollTo(0, 0);
    },

    goToStep(step) {
      /*
      alert(this.getSiteVersionStatus != 'PROD');
       */
      /*
      alert(step);

       */
      //alert(this.getStepIndex(this.currentTab));
      //alert(this.getStepIndex(step));

      /*
      if (
        this.getSiteVersionStatus != 'PROD' &&
        !this.isCurrentStepIndexGreaterThan(step)
      ) {
        return;
      }*/
      this.currentTab = step;
      this.postSiteVersion();
    },

    getStepIndex(step) {
      switch (step) {
        case 'GlobalSettings':
          return 0;
        case 'SpecialityTab':
          return 1;
        case 'LawFirm':
          return 1;
        case 'Coworkers':
          return 2;
        case 'DesignSettings':
          return 3;
        case 'Legals':
          return 4;
        case 'LiveEdit':
          return 5;
      }
    },

    isCurrentStepIndexGreaterThan(step) {
      return this.getStepIndex(this.currentTab) > this.getStepIndex(step);
    },

    save() {
      this.updateSiteVersionStatus(this.statusDraft);
      this.postSiteVersion();
      this.showSaveModal = true;
      setTimeout(() => {
        this.showSaveModal = false;
      }, 2000);
    },

    publish() {
      this.updateSiteVersionStatus(this.statusProd);
      this.postSiteVersion();
      this.showPublishModal = true;
      setTimeout(() => {
        this.showPublishModal = false;
      }, 2000);
    },

    async postSiteVersion() {
      //const { data: office } =
      await api.patch(this.getOffice.uri, this.getOffice);

      await api.get(this.getOffice.uri);

      //this.updateOffice(office);
      const { data } = await api.post('/site_versions', {
        ...this.getSiteVersionState,
        site: this.getSite.uri,
      });
      this.updateOnLineUpdated(data.onLine);
      if (data) {
        if (data.site) {
          this.updateSite(data.site);
          if (data.site.office) {
            if (data.site.office.specialities) {
              let names = [];
              data.site.office.specialities.forEach(speciality => {
                names.push(speciality['@id']);
              });
              this.updateOfficeSpecialities(names);
            }
          }
        }
      }

      this.updateSiteHostingSettings(data.site.hostingSettings);
    },
  },
};
</script>
